export default __webpack_public_path__ + "static/media/misc-books5-1920w.1bb49527.webp";